export default {
  title: 'Transferir sitio web',
  buttons: {
    cancel: 'Cancelar',
    transfer: 'Transferir',
  },
  fields: {
    target_franchise: {
      label: 'Franquicia de destino',
      description: 'Selecciona la franquicia a la que transferir el sitio web',
    },
    sync_companies: {
      label: 'Asignaciones de empresas',
      description: 'Asigna empresas de la franquicia de destino a empresas del storefront',
      franchise_company: 'Empresa de franquicia',
      storefront_company: 'Empresa del storefront',
      select_franchise_company: 'Seleccionar empresa de franquicia',
      select_storefront_company: 'Seleccionar empresa del storefront',
      franchise_company_required: 'La empresa de franquicia es obligatoria',
      storefront_company_required: 'La empresa del storefront es obligatoria',
    },
  },
  toasts: {
    failed_to_load_companies: 'Error al cargar las empresas',
    no_companies_selected: 'Añade al menos una asignación de empresa',
    failed_to_transfer: 'Error al transferir el sitio web',
    transfer_success: 'Sitio web transferido correctamente',
    franchise_already_connected: 'La franquicia de destino ya está conectada a un sitio web',
  },
};
